/**
 * Downvote controller - handles downvote business logic
 */

import * as promptLibraryService from '../../data/services/promptLibraryService';
import { Prompt } from '../../domain/models/Prompt';
import { toggleVote } from '../../../../shared/data/promptsRepo';

/**
 * Toggle downvote for a prompt
 * @returns {Promise<Object>} Updated prompt with interaction status
 */
export const toggleDownvote = async (promptId) => {
  const result = await toggleVote(promptId, 'downvote');
  // result.voteType will be 'upvote', 'downvote', or null
  const isUpvoted = result.voteType === 'upvote';
  const isDownvoted = result.voteType === 'downvote';

  return {
    prompt: Prompt.fromData(result.prompt),
    isUpvoted,
    isDownvoted,
  };
};

/**
 * Check if user has downvoted a prompt
 * @returns {Promise<boolean>} True if downvoted
 */
export const isDownvoted = async (promptId, userId, organizationId) => {
  const interactions = await promptLibraryService.getUserPromptInteractions(
    userId,
    organizationId,
    promptId
  );
  return interactions.downvoted;
};
